/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Card, Typography, Box, Grid, useTheme,
} from '@material-ui/core';
import BuildIcon from '@material-ui/icons/Build';
import ErrorIcon from '@material-ui/icons/Error';
import SvgIcon from '@material-ui/core/SvgIcon';
import useSWR from 'swr';
import axios from 'axios';
import Slider from 'react-slick';
import { Skeleton } from '@material-ui/lab';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { ReactComponent as ScanIcon } from '../../assets/icons/scan.svg';
import ImageModal from '../packer/ImageModal';

interface RepairCardProps {
  barcode: string,
  error?: boolean,
  iconType?: 'repair' | 'barcode',
  primaryText?: string,
  secondaryText?: string,
  destinationBinName?: string,
  hideArrows?: boolean,
  hideUnderCard?: boolean,
}

const RepairCardCarousel: React.FC<RepairCardProps> = ({
  barcode = 'Missing Number', error, iconType = 'barcode', primaryText = 'Current Barcode', secondaryText = 'Barcode Number', destinationBinName, hideArrows = false, hideUnderCard = false,
}) => {
  const [isDragging, setIsDragging] = React.useState(false);
  const [imageModalOpen, setImageModalOpen] = React.useState<boolean>(false);
  const [selectedImage, setSelectedImage] = React.useState<string>('');
  const theme = useTheme();

  const imageFetcher = (url: string, repairBarcodeParam: string) => axios.get<{ photoUrls:string[] }>(url, {
    params: {
      repairBarcode: repairBarcodeParam,
      thumbnails: false,
    },
  }).then((res) => res.data);

  const settings = {
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
  };

  const placeholderArray = new Array(5);

  const { data: images } = useSWR(barcode ? ['/MetalCollection/GetRepairImages', barcode] : null, (url, repairBarcodeParam) => imageFetcher(url, repairBarcodeParam));

  return (
    <Grid container spacing={1}>
      <ImageModal onCloseFunction={() => setImageModalOpen(false)} imageUrls={[selectedImage]} open={imageModalOpen} />
      <Grid item xs={12}>
        <Box sx={{ m: 4.5 }}>
          <Slider
            {...settings}
            arrows={!hideArrows}
            onSwipe={() => { setIsDragging(true); }}
            afterChange={() => { setIsDragging(true); setTimeout(() => { setIsDragging(false); }, 100); }}
          >
            {
              images
                ? images?.photoUrls.map((item) => (
                  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                  <div
                    key={item}
                    onClick={() => { if (isDragging === false) { setSelectedImage(item); setImageModalOpen(true); } }}
                  >
                    <img
                      src={item}
                      alt="repair"
                      style={{
                        objectFit: 'scale-down',
                        width: '100%',
                      }}
                    />
                  </div>
                ))
                : (
                  placeholderArray.map(() => (
                    <Skeleton variant="rect" width="100%" height="100%">
                      <img
                        alt="repair-placeholder"
                        style={{
                          objectFit: 'scale-down',
                          width: '100%',
                        }}
                      />
                    </Skeleton>
                  ))
                )
            }
          </Slider>
        </Box>
      </Grid>
      { !hideUnderCard
      && (
      <Grid item xs={12} sm={destinationBinName ? 8 : 12}>
        <Card style={{ height: '100%' }}>
          <Box p={2} clone>
            <Grid container alignItems="flex-end" spacing={3}>
              <Grid item>
                { (iconType === 'repair')
                  ? <BuildIcon />
                  : <SvgIcon component={ScanIcon} viewBox="0 0 16 17" />}
              </Grid>
              <Grid item>
                <Typography variant="h6">
                  {primaryText}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h6">
                  {`${barcode} `}
                  {error && <ErrorIcon style={{ color: 'red', marginBottom: '0.20em' }} />}
                </Typography>
              </Grid>
              <Grid item style={{ marginLeft: 'auto' }}>
                <Typography color="textSecondary" gutterBottom>
                  {secondaryText}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Card>
      </Grid>
      )}
      { destinationBinName && (
      <Grid
        item
        xs={12}
        sm={4}
      >
        <Card style={{ height: '100%' }}>
          <Box p={2}>
            <Typography variant="h5" style={{ fontSize: '1.125rem', color: theme.palette.primary.main }}>
              {`Repair Destination: ${destinationBinName}`}
            </Typography>
          </Box>
        </Card>
      </Grid>
      )}
    </Grid>
  );
};

export default RepairCardCarousel;
